<template>
  <div>
    <div class="title">设置信息</div>
    <Form ref="settingForm" :rules="ruleValidate" :model="settingInfo" :label-width="120">
      <FormItem label="排课截止时间" prop="dispatch_ending_time">
        <Select
          v-model="settingInfo.dispatch_ending_week"
          :disabled="!editable"
          style="width:100px"
        >
          <Option :value="1">周一</Option>
          <Option :value="2">周二</Option>
          <Option :value="3">周三</Option>
          <Option :value="4">周四</Option>
          <Option :value="5">周五</Option>
          <Option :value="6">周六</Option>
          <Option :value="7">周日</Option>
        </Select>
        <TimePicker
          format="HH:mm"
          placeholder="请选择排课截止时间"
          v-model="settingInfo.dispatch_ending_time"
          :disabled="!editable"
          style="width: 150px"
        ></TimePicker>
        <span class="tip">如：周三 24:00 点，即 每周三晚上24点不能再排课</span>
      </FormItem>
      <FormItem label="放课时间" prop="open_start_time">
        <Select v-model="settingInfo.open_start_week" :disabled="!editable" style="width:100px">
          <Option :value="1">周一</Option>
          <Option :value="2">周二</Option>
          <Option :value="3">周三</Option>
          <Option :value="4">周四</Option>
          <Option :value="5">周五</Option>
          <Option :value="6">周六</Option>
          <Option :value="7">周日</Option>
        </Select>
        <TimePicker
          format="HH:mm"
          placeholder="请选择放课时间"
          v-model="settingInfo.open_start_time"
          :disabled="!editable"
          style="width: 150px"
        ></TimePicker>
        <span class="tip">如：周四 12:00 点，即 每周四中午12点开放下周预约课程</span>
      </FormItem>
      <FormItem label="预约截止时间" prop="reservation_ending_time">
        <span>开课前</span>
        <Input
          style="width:100px"
          type="number"
          v-model="settingInfo.reservation_ending_time"
          placeholder="请输入"
          :maxlength="50"
          :disabled="!editable"
        />
        <span>分钟</span>
        <span class="tip">学员开课前多长时间截止预约</span>
      </FormItem>
      <FormItem label="取消预约截止时间" prop="cancel_reservation_time">
        <span>开课前</span>
        <Input
          style="width:100px"
          type="number"
          v-model="settingInfo.cancel_reservation_time"
          placeholder="请输入"
          :maxlength="50"
          :disabled="!editable"
        />
        <span>分钟可取消预约</span>
        <span class="tip">学员开课前多长时间可以取消预约</span>
      </FormItem>
      <FormItem label="提前进入教室时间">
        <RadioGroup v-model="settingInfo.advance_enter_class_time_setting">
          <Radio :label="0" :disabled="!editable">任意时间</Radio>
          <Radio :label="1" :disabled="!editable">手动调整</Radio>
        </RadioGroup>
        <span v-if="settingInfo.advance_enter_class_time_setting==1">
          <Input
            style="width:100px"
            type="number"
            v-model="settingInfo.advance_enter_class_time"
            placeholder="请输入"
            :maxlength="50"
            :disabled="!editable"
          />
          <span>分钟</span>
        </span>
      </FormItem>
      <FormItem label="单节课时时长" prop="chapter_time">
        <RadioGroup
          v-model="settingInfo.chapter_time_setting"
          @on-change="chapterTimeChange"
          :disabled="!editable"
        >
          <Radio label="0" :disabled="!editable">25分钟</Radio>
          <Radio label="1" :disabled="!editable">45分钟</Radio>
          <Radio label="2" :disabled="!editable">自定义</Radio>
        </RadioGroup>
        <span v-if="settingInfo.chapter_time_setting=='2'">
          <Input
            style="width:100px"
            type="number"
            v-model="settingInfo.chapter_time"
            placeholder="请输入"
            :maxlength="50"
            :disabled="!editable"
          />
          <span>分钟</span>
        </span>
        <span class="tip">所有老师单个课时时长相同</span>
      </FormItem>
      <FormItem label="课时间隔时长" prop="chapter_interval_time">
        <RadioGroup
          v-model="settingInfo.chapter_interval_time_setting"
          @on-change="chapterIntervalSetting"
        >
          <Radio label="0" :disabled="!editable">5分钟</Radio>
          <Radio label="1" :disabled="!editable">15分钟</Radio>
          <Radio label="2" :disabled="!editable">自定义</Radio>
        </RadioGroup>
        <span v-if="settingInfo.chapter_interval_time_setting=='2'">
          <Input
            style="width:100px"
            type="number"
            v-model="settingInfo.chapter_interval_time"
            placeholder="请输入"
            :maxlength="50"
            :disabled="!editable"
          />
          <span>分钟</span>
        </span>
        <span class="tip">课时与课时之间的间隔时长</span>
      </FormItem>
      <FormItem label="预约时间段" prop="reservation_time">
        <div v-for="(item,index) in settingInfo.reservation_time" :key="index">
          <TimePicker
            v-model="settingInfo.reservation_time[index]"
            format="HH:mm"
            type="timerange"
            placement="bottom-end"
            placeholder="选择预约时间段"
            :disabled="!editable"
            style="width: 168px"
          ></TimePicker>
          <Button
            type="default"
            icon="ios-add"
            @click="addTimeRange"
            v-if="index==0&&editable"
          >增加时间段</Button>
          <Button
            type="default"
            icon="ios-remove"
            v-if="index>0&&editable"
            @click="removeTimeRange(index)"
          >删除时间段</Button>
        </div>
      </FormItem>
      <FormItem style="text-align:center">
        <Button
          size="large"
          style="margin: 0 15px;"
          type="primary"
          @click="editable=true"
          v-if="!editable"
        >编辑</Button>
        <Button
          size="large"
          style="margin: 0 15px;"
          type="primary"
          @click="submitForm('settingForm')"
          v-else
        >保存</Button>
      </FormItem>
    </Form>
  </div>
</template>
<script>
export default {
  name: "TeachOtoSetting",
  data() {
    return {
      editable: false,
      settingInfo: {
        id: "",
        dispatch_ending_week: 1,
        dispatch_ending_time: "",
        open_start_week: 2,
        open_start_time: "",
        reservation_ending_time: "",
        cancel_reservation_time: "",
        advance_enter_class_time_setting: 0,
        advance_enter_class_time: "",
        chapter_time_setting: "0",
        chapter_time: "25",
        chapter_interval_time_setting: "0",
        chapter_interval_time: "5",
        reservation_time: [["", ""]]
      },
      ruleValidate: {
        dispatch_ending_time: [
          {
            required: true,
            message: "排课截止时间不能为空",
            trigger: "change"
          }
        ],
        open_start_time: [
          {
            required: true,
            message: "放课时间不能为空",
            trigger: "change"
          }
        ],
        reservation_ending_time: [
          {
            required: true,
            type: "string",
            message: "预约截止时间不能为空",
            trigger: "blur"
          }
        ],
        cancel_reservation_time: [
          {
            required: true,
            type: "string",
            message: "取消预约截止时间不能为空",
            trigger: "blur"
          }
        ],
        chapter_time: [
          {
            required: true,
            message: "单节课时时长不能为空",
            type: "string",
            trigger: "blur"
          }
        ],
        chapter_interval_time: [
          {
            required: true,
            message: "课时间隔时长不能为空",
            type: "string",
            trigger: "blur"
          }
        ],
        reservation_time: [
          {
            required: true,
            type: "array",
            min: 1,
            message: "预约时间段不能为空",
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    addTimeRange() {
      this.settingInfo.reservation_time.push(["", ""]);
    },
    removeTimeRange(index) {
      this.settingInfo.reservation_time.splice(index, 1);
    },
    chapterTimeChange() {
      let setting = this.settingInfo.chapter_time_setting;
      if (setting == "0") {
        this.settingInfo.chapter_time = "25";
      } else if (setting == "1") {
        this.settingInfo.chapter_time = "45";
      } else if (setting == "2") {
        this.settingInfo.chapter_time = "";
      }
    },
    chapterIntervalSetting() {
      let setting = this.settingInfo.chapter_interval_time_setting;
      if (setting == "0") {
        this.settingInfo.chapter_interval_time = "5";
      } else if (setting == "1") {
        this.settingInfo.chapter_interval_time = "15";
      } else if (setting == "2") {
        this.settingInfo.chapter_interval_time = "";
      }
    },
    submitForm(ref) {
      this.$refs[ref].validate(async valid => {
        if (!valid) {
          return;
        }
        let data = {};
        data.dispatch_ending_time =
          this.settingInfo.dispatch_ending_week +
          "," +
          this.settingInfo.dispatch_ending_time;
        data.open_start_time =
          this.settingInfo.open_start_week +
          "," +
          this.settingInfo.open_start_time;
        data.reservation_ending_time = this.settingInfo.reservation_ending_time.toString();
        data.cancel_reservation_time = this.settingInfo.cancel_reservation_time.toString();
        data.advance_enter_class_time =
          this.settingInfo.advance_enter_class_time_setting == 0
            ? 0
            : this.settingInfo.advance_enter_class_time;
        data.chapter_time = this.settingInfo.chapter_time;
        data.chapter_interval_time = this.settingInfo.chapter_interval_time;
        let ranges = [];
        this.settingInfo.reservation_time.forEach(t => {
          ranges.push({ start_time: t[0], end_time: t[1] });
        });
        data.reservation_time = JSON.stringify(ranges);
        data.flag = 1;
        let result;
        if (this.settingInfo.id) {
          result = await this.$http.put(
            "/api/oto/reservation/setting/" + this.settingInfo.id,
            data
          );
        } else {
          result = await this.$http.post("/api/oto/reservation/setting", data);
          this.settingInfo.id = result.id;
        }
        await this.$promiseConfirm(result.id, "提示", {
          okText: "知道了，保存更改",
          cancelText: "暂不更改",
          onCancel: async () => {
            this.editable = false;
            await this.getData();
          }
        });
        data.flag = 0;
        await this.$http.put(
          "/api/oto/reservation/setting/" + this.settingInfo.id,
          data
        );
        this.$Message.saveSuccess();
        this.editable = false;
      });
    },
    async getData() {
      let data = await this.$http.get("/api/oto/reservation/setting/id");
      if (!data) {
        return;
      }
      this.settingInfo.id = data.id;
      if (data.dispatch_ending_time) {
        let array = data.dispatch_ending_time.split(",");
        this.settingInfo.dispatch_ending_week = parseInt(array[0]);
        this.settingInfo.dispatch_ending_time = array[1];
      }
      if (data.open_start_time) {
        let array = data.open_start_time.split(",");
        this.settingInfo.open_start_week = parseInt(array[0]);
        this.settingInfo.open_start_time = array[1];
      }
      this.settingInfo.reservation_ending_time = data.reservation_ending_time.toString();
      this.settingInfo.cancel_reservation_time = data.cancel_reservation_time.toString();
      this.settingInfo.advance_enter_class_time_setting =
        data.advance_enter_class_time > 0 ? 1 : 0;
      this.settingInfo.advance_enter_class_time = data.advance_enter_class_time;
      this.settingInfo.chapter_time = data.chapter_time.toString();
      if (data.chapter_time == 25) {
        this.settingInfo.chapter_time_setting = "0";
      } else if (data.chapter_time == 45) {
        this.settingInfo.chapter_time_setting = "1";
      } else {
        this.settingInfo.chapter_time_setting = "2";
      }
      this.settingInfo.chapter_interval_time = data.chapter_interval_time.toString();
      if (data.chapter_interval_time == 5) {
        this.settingInfo.chapter_interval_time_setting = "0";
      } else if (data.chapter_interval_time == 15) {
        this.settingInfo.chapter_interval_time_setting = "1";
      } else {
        this.settingInfo.chapter_interval_time_setting = "2";
      }
      let timeRanges = [];
      data.reservation_time.forEach(t => {
        timeRanges.push([t.start_time, t.end_time]);
      });
      this.settingInfo.reservation_time = timeRanges;
    }
  },
  async created() {
    await this.getData();
  }
};
</script>
<style lang="scss" scoped>
.tip {
  color: red;
  margin-left: 10px;
}
</style>